// import Icon from '@ant-design/icons';
import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import { LoadingOutlined, HomeOutlined } from "@ant-design/icons";
import { Tabs, Radio, Row, Col } from "antd";
import ZenVerBarChart from "./Common/Graph/ZenVerBarChart";
import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import digitalFactoryLogo from "../../images/DigitalFactory.png";
import { Link } from "react-router-dom";
import { getUrlCode } from "../../utils/CustomFunc";
// import RadialGradient from 'react-native-radial-gradient';

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

class ZenChartMultiFunction extends React.Component {
  state = {
    mainData: null,
    ZenVerBarChart1: null,
    ZenVerBarChart2: null,
    ZenVerBarChart3: null,
    ZenVerBarChart4: null,
    ZenVerBarChart5: null,
    ZenVerBarChart6: null,
    ZenVerBarChart7: null,
    ZenVerBarChart8: null,
    ZenVerBarChart9: null,
    // ZenVerBarChartA: null,
    // ZenVerBarChartB: null,
    // ZenVerBarChartC: null,

    // ZenGanttChart: null,
    // ZenDonut: null,
    // ZenVerBarChart: null,
    // ZenHorBarChart: null,
    // ZenPareto: null,

    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "all",
    tabsData: null,
    selectedMnt: "all",
    table: null,
    dataLoading: false,
    selectedGraphParams: {},
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  onChange = (e) => {

    const st = this;
    this.setState({
      ...this.state,
      selectedTab: e.target.value,
      loading: true,
    });
    this.fetchTrendData(e.target.value);
  };

  changeLid = (lid) => {
    let val =
      this.state.lid === "all" ? lid : this.state.lid === lid ? "all" : lid;
    this.setState({ ...this.state, lid: val, dataLoading: true });
    this.fetchTrendData(this.state.selectedTab, val, this.state.selectedMnt);
  };

  getTabs() {
    liracrypt
      .get("/corp/corpdashdynamicparam", this.props.urlData || {})
      .then((response) => {
        let __tabs = response.data.data;
        this.setState(
          {
            tabsData: __tabs,
            selectedTab: __tabs?.find((x) => x.isDefault === true)?.subTyp,
          },
          () => {
            if (this._isMounted && this.state.selectedTab) {
              this.fetchTrendData(this.state.selectedTab);
            }
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    this.props.setPageHeader("ZenChart MultiFunction");
    this._isMounted = true;
    this.getTabs();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  onGraphClick = ({ apiUrl, urlData, changeKey }) => {
    this.setState({
      ...this.state,
      dataLoading: true
    })
    let params = Object.keys(this.state.selectedGraphParams).length
      ? { ...this.state.selectedGraphParams }
      : { ...urlData };
    if (this.state.selectedGraphParams[changeKey] === urlData[changeKey]) {
      params[changeKey] = "all";
    } else {
      params[changeKey] = urlData[changeKey];
    }
    this.setState({
      ...this.state,
      selectedGraphParams: params,
    });
    liracrypt
      .get(apiUrl, params)
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};
        respData["ZenVerBarChart1"] = resp["data"]["ZenVerBarChart1"];
        respData["ZenVerBarChart2"] = resp["data"]["ZenVerBarChart2"];
        respData["ZenVerBarChart3"] = resp["data"]["ZenVerBarChart3"];
        respData["ZenVerBarChart4"] = resp["data"]["ZenVerBarChart4"];
        respData["ZenVerBarChart5"] = resp["data"]["ZenVerBarChart5"];
        respData["ZenVerBarChart6"] = resp["data"]["ZenVerBarChart6"];
        respData["ZenVerBarChart7"] = resp["data"]["ZenVerBarChart7"];

        respData["mainData"] = { ...resp };
        this.setState(
          {
            ...this.state,
            ...respData,
            loading: false,
            dataLoading: false,
          },
          () => { }
        );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  fetchTrendData = (selectedTab, lid = "all", mnt = "all", sh = "all") => {
    liracrypt
      .get("/chart/charttemplate", {
        lid,
        mnt,
        sh,
        typ: "MainGraph",
        subTyp: selectedTab,
        chartGroup: "ZenChartMultiFunction"
      })
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};
        respData["ZenVerBarChart1"] = resp["data"]["ZenVerBarChart1"];
        respData["ZenVerBarChart2"] = resp["data"]["ZenVerBarChart2"];
        respData["ZenVerBarChart3"] = resp["data"]["ZenVerBarChart3"];
        respData["ZenVerBarChart4"] = resp["data"]["ZenVerBarChart4"];
        respData["ZenVerBarChart5"] = resp["data"]["ZenVerBarChart5"];
        respData["ZenVerBarChart6"] = resp["data"]["ZenVerBarChart6"];
        respData["ZenVerBarChart7"] = resp["data"]["ZenVerBarChart7"];
        // respData["ZenVerBarChart8"] = resp["data"]["ZenVerBarChart8"];
        // respData["ZenVerBarChart9"] = resp["data"]["ZenVerBarChart9"];

        // respData["ZenVerBarChartA"] = resp["data"]["ZenVerBarChartA"];
        // respData["ZenVerBarChartB"] = resp["data"]["ZenVerBarChartB"];
        // respData["ZenVerBarChartC"] = resp["data"]["ZenVerBarChartC"];

        // respData["ZenGanttChart"] = resp["data"]["ZenGanttChart"];
        // respData["ZenDonut"] = resp["data"]["ZenDonut"];
        // respData["ZenVerBarChart"] = resp["data"]["ZenVerBarChart"];
        // respData["ZenHorBarChart"] = resp["data"]["ZenHorBarChart"];
        // respData["ZenPareto"] = resp["data"]["ZenPareto"];
        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  graphLoader() {
    return (
      <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', alignItems: 'center', width: 'inherit', height: 'inherit' }}>
        <Spin indicator={antIcon} />
      </div>
    )
  }

  changeBasicGraph(data) {
    let val =
      this.state.selectedMnt === "all"
        ? data._id
        : this.state.selectedMnt === data._id
          ? "all"
          : data._id;
    this.setState({
      selectedMnt: val,
      dataLoading: true,
    });
    this.fetchTrendData(this.state.selectedTab, this.state.lid, val);
  }

  render() {
    if (this.state.mainData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div
            style={{
              background: "#000000",
              paddingTop: 10,
              //   backgroundImage:
              //     "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
            }}
          >
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: 'wrap',
                width: "100%",
              }}
            >
              <div
                className="logo"
                style={{
                  margingLeft: 14,
                  padding: 10,
                }}
              >
                <img src={digitalFactoryLogo} alt="sarex" width="80" />
              </div>
              <Radio.Group
                className="managerTabs"
                value={"small"}
                onChange={this.onChange}
              >
                {this.state.tabsData &&
                  this.state.tabsData.map((tab, index) => (
                    <Radio.Button
                      key={index}
                      className={tab?.label?.toLowerCase()}
                      style={{
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        color: tab?.color,
                        textAlign: "center",
                        fontSize: "17px",
                        fontWeight: 600,
                        boxShadow: boxShadow,
                        maxWidth: "200px",
                      }}
                      value={tab?.subTyp}
                    >
                      {tab?.label}
                    </Radio.Button>
                  ))}
              </Radio.Group>
              <div
                style={{
                  //   boxShadow:
                  //     "rgb(30 30 30) 5px 5px 10px, rgb(46 46 46) -5px -5px 10px",
                  borderRadius: 10,
                  padding: 10,
                  marginRight: 25,
                  marginBottom: 13,

                  background: "#191C24",
                  //   backgroundImage:
                  //     "linear-gradient(145deg, rgba(106,106,111,1) 0%, rgba(42,42,52,0.8748541652989321) 57%, rgba(33,32,40,1) 100%)",
                  border: "1px solid #3c3e4f",
                }}
              >
                <Link to={`/v02/${getUrlCode()}/dashboard`}>
                  <HomeOutlined
                    style={{
                      fontSize: 25,
                    }}
                  />
                </Link>
              </div>
            </div>
            {this.state.loading === false ? (
              <div>

                {/* ____________________________________START_____________________________________ */}

                <Row style={{ background: "#000000" }}>
                  <Col span={8}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: 10,
                        height: "320px",
                        width: "98%",
                      }}
                    >
                      {
                        this.state.dataLoading ?
                          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'inherit' }}>
                            <Spin indicator={antIcon} />
                          </div> :
                          <ZenVerBarChart
                            divId={"ZenVerBarChart1"}
                            data={this.state.ZenVerBarChart1.data}
                            config={this.state.ZenVerBarChart1.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                      }
                    </div>
                  </Col>

                  <Col span={8}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: 10,
                        height: "320px",
                        width: "98%",
                      }}
                    >
                      {
                        this.state.dataLoading ?
                          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'inherit' }}>
                            <Spin indicator={antIcon} />
                          </div> :
                          <ZenVerBarChart
                            divId={"ZenVerBarChart2"}
                            data={this.state.ZenVerBarChart2.data}
                            config={this.state.ZenVerBarChart2.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                      }
                    </div>
                  </Col>
                  <Col span={8}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: 10,
                        height: "320px",
                        width: "98%",
                      }}
                    >
                      {
                        this.state.dataLoading ?
                          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'inherit' }}>
                            <Spin indicator={antIcon} />
                          </div> :
                          <ZenVerBarChart
                            divId={"ZenVerBarChart3"}
                            data={this.state.ZenVerBarChart3.data}
                            config={this.state.ZenVerBarChart3.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                      }
                    </div>
                  </Col>
                </Row>
                <Row style={{ background: "#000000" }}>
                  <Col span={8}>

                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: 10,
                        height: "320px",
                        width: "98%",
                      }}
                    >
                      {
                        this.state.dataLoading ?
                          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'inherit' }}>
                            <Spin indicator={antIcon} />
                          </div> :
                          <ZenVerBarChart
                            divId={"ZenVerBarChart4"}
                            smodalCallback={() => this.fetchTrendData(this.state.selectedTab)}
                            data={this.state.ZenVerBarChart4.data}
                            config={this.state.ZenVerBarChart4.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                      }
                    </div>
                  </Col>
                  <Col span={8}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: 10,
                        height: "320px",
                        width: "98%",
                      }}
                    >
                      {
                        this.state.dataLoading ?
                          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'inherit' }}>
                            <Spin indicator={antIcon} />
                          </div> :
                          <ZenVerBarChart
                            divId={"ZenVerBarChart5"}
                            data={this.state.ZenVerBarChart5.data}
                            config={this.state.ZenVerBarChart5.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                      }
                    </div>
                  </Col>
                  <Col span={8}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: 10,
                        height: "320px",
                        width: "98%",
                      }}
                    >
                      {
                        this.state.dataLoading ?
                          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'inherit' }}>
                            <Spin indicator={antIcon} />
                          </div> :
                          <ZenVerBarChart
                            divId={"ZenVerBarChart6"}
                            data={this.state.ZenVerBarChart6.data}
                            config={this.state.ZenVerBarChart6.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                      }
                    </div>
                  </Col>
                </Row>

                <Row style={{ background: "#000000" }}>
                  <Col span={8}>
                    <div
                      style={{
                        borderRadius: "10px",
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        margin: 10,
                        height: "320px",
                        width: "98%",
                      }}
                    >
                      {
                        this.state.dataLoading ?
                          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'inherit' }}>
                            <Spin indicator={antIcon} />
                          </div> :
                          <ZenVerBarChart
                            divId={"ZenVerBarChart7"}
                            data={this.state.ZenVerBarChart7.data}
                            config={this.state.ZenVerBarChart7.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                      }
                    </div>
                  </Col>

                </Row>
              </div>
            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}

export default ZenChartMultiFunction;
